import HttpClient from "../../../service/HttpService";
import state from "./state";

export default {
  login({ commit }, user) {
    return new Promise((resolve, reject) => {
      HttpClient.backApi
        .post("/auth/create", user)
        .then(response => {
          const token = response.data.access_token;
          localStorage.setItem("token", token);
          HttpClient.backApi.defaults.headers.common["X-Auth-Token"] = token;
          commit("auth_success", { token });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  logout({ commit }) {
    return new Promise(resolve => {
      commit("logout");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      resolve();
    });
  },
  getUser() {
    return new Promise((resolve) => {
      if (state.user) {
        resolve(state.user);
      } else {
        HttpClient.backApi.get("/auth/clarify").then(response => {
          state.user = response.data;
          resolve(state.user);
        });
      }
    });
  },
  saveToken({ commit }, token) {
    localStorage.setItem("token", token);
    HttpClient.backApi.defaults.headers.common["X-Auth-Token"] = token;
    commit("auth_success", { token });
  }
};
